import React from 'react';
import { ContentBlock } from '@/types/case-study';
import { isContentBlockRemovable } from '@/types/case-study';
import { TextBlock } from './TextBlock';
import { ImageBlock } from './ImageBlock';
import { VideoBlock } from './VideoBlock';
import { GalleryBlock } from './GalleryBlock';
import { CarouselBlock } from './CarouselBlock';
import { LineBreakBlock } from './LineBreakBlock';
import { QuoteBlock } from './QuoteBlock';
import { CalloutBlock } from './CalloutBlock';

interface ContentBlockRendererProps {
  block: ContentBlock;
  onUpdate: (content: any) => void;
  onRemove?: () => void;
  isActive?: boolean;
}

export const ContentBlockRenderer: React.FC<ContentBlockRendererProps> = ({
  block,
  onUpdate,
  onRemove,
  isActive = false,
}) => {
  const handleUpdate = (content: any) => {
    onUpdate(content);
  };

  const isRemovable = isContentBlockRemovable(block.type);

  switch (block.type) {
    case "text":
      return (
        <TextBlock
          block={block}
          onUpdate={handleUpdate}
          onRemove={isRemovable ? onRemove : undefined}
          isActive={isActive}
          isRemovable={isRemovable}
        />
      );
    
    case "image":
      return (
        <ImageBlock
          block={block}
          onUpdate={handleUpdate}
          onRemove={isRemovable ? onRemove : undefined}
          isActive={isActive}
          isRemovable={isRemovable}
        />
      );
    
    case "video":
      return (
        <VideoBlock
          block={block}
          onUpdate={handleUpdate}
          onRemove={isRemovable ? onRemove : undefined}
          isActive={isActive}
          isRemovable={isRemovable}
        />
      );
    
    case "gallery":
      return (
        <GalleryBlock
          block={block}
          onUpdate={handleUpdate}
          onRemove={isRemovable ? onRemove : undefined}
          isActive={isActive}
          isRemovable={isRemovable}
        />
      );
    
    case "carousel":
      return (
        <CarouselBlock
          block={block}
          onUpdate={handleUpdate}
          onRemove={isRemovable ? onRemove : undefined}
          isActive={isActive}
          isRemovable={isRemovable}
        />
      );
    
    case "line-break":
      return (
        <LineBreakBlock
          block={block}
          onUpdate={handleUpdate}
          onRemove={isRemovable ? onRemove : undefined}
          isActive={isActive}
          isRemovable={isRemovable}
        />
      );
    
    case "quote":
      return (
        <QuoteBlock
          block={block}
          onUpdate={handleUpdate}
          onRemove={isRemovable ? onRemove : undefined}
          isActive={isActive}
          isRemovable={isRemovable}
        />
      );

    case "callout":
      return (
        <CalloutBlock
          block={block}
          onUpdate={handleUpdate}
          onRemove={isRemovable ? onRemove : undefined}
          isActive={isActive}
          isRemovable={isRemovable}
        />
      );

    default:
      console.warn(`Unknown content block type: ${block.type}`);
      return null;
  }
};
